// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jjSmH{gap:8px;padding:40px}.msbdO{color:#9393b1}.unoxl{margin-bottom:16px}._kmX2{align-items:center;padding:24px 0}.vM4LX{margin-top:16px;margin-bottom:8px}.tIc8y{display:inline-flex;align-items:center;gap:6px;padding:4px 12px;border-radius:16px;background-color:#eaeaef}.hlNVU{width:100%;margin:16px 0}.KMn5C{width:100%;gap:12px}.taDTu{display:flex;align-items:center;gap:8px}.Bvkdj{width:8px;height:8px;border-radius:50%;background-color:#bfbfd0;flex-shrink:0}.Bvkdj.nqBJ6{background-color:#6942f8}.elXcE{width:8px;height:8px;display:flex;align-items:center;justify-content:center;color:#6942f8;flex-shrink:0;font-size:12px}.vXY1e{color:#6942f8}.yURCa{color:#9393b1}._xYVq{align-items:center;padding:24px 0}.R7XPV{margin-bottom:12px}.AEMNG{margin-bottom:8px;text-align:center}.suWkf{text-align:center;max-width:400px}._3bPKD{display:flex;align-items:center;justify-content:center;gap:8px;margin-bottom:16px}.XY9Up{display:flex;gap:4px}.Tn0Sh{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"uploadDropzone": `jjSmH`,
	"hint": `msbdO`,
	"subtitle": `unoxl`,
	"analyzingContent": `_kmX2`,
	"analyzingTitle": `vM4LX`,
	"fileNameChip": `tIc8y`,
	"divider": `hlNVU`,
	"stepsContainer": `KMn5C`,
	"step": `taDTu`,
	"stepDot": `Bvkdj`,
	"stepDotActive": `nqBJ6`,
	"stepCheckmark": `elXcE`,
	"stepTextActive": `vXY1e`,
	"stepTextComplete": `yURCa`,
	"errorContent": `_xYVq`,
	"errorIconContainer": `R7XPV`,
	"errorTitle": `AEMNG`,
	"errorDescription": `suWkf`,
	"feedbackRow": `_3bPKD`,
	"thumbButtons": `XY9Up`,
	"errorFooter": `Tn0Sh`
};
export default ___CSS_LOADER_EXPORT___;
